import "./Main.css"

export default function Main() {
    return (
        <div className="main">
        <h2>Desired Position</h2>
        <p>Junior JavaScript Developer</p>
        <h2>About</h2>
        <p>I'm a self-taught frontend developer looking to gain experience working on commercial projects. I'm following The Odin Project curriculum to become a full-stack JavaScript developer.</p>
        <h2>Interests</h2>
        <p>When not coding and before the pandemic, I've done several major cycling tours and studied Spanish for the next adventure. Now I'm filling the void by running by the sea. </p>
        </div>
    )
}